import React, { Component } from 'react';
import '../../styles/components/header-banner.scss';

class HeaderBanner extends Component {
  render() {
    const { title, subtitle, variant, icon } = this.props;

    return (
      <>
        <div className={`header-banner ${variant || ''}`}>
          <div className="header-content">
            <h1 className="header-title">
              {icon && <span className="header-icon">{icon}</span>}
              {title}
            </h1>
            {subtitle && <p className="header-subtitle">{subtitle}</p>}
          </div>
        </div>
        <div className="headerbannerBreake"></div>
      </>
    );
  }
}

export default HeaderBanner;
